import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
function Navbar() {
  return (
    <nav className="navbar">
        <img src={logo} alt="Radha Traders Logo" className="hero-logo" />

      {/* <h2>Radha Traders</h2> */}
      <div>
        <Link to="/">Home</Link>
        <Link to="/products">Products</Link>
        <Link to="/about">About</Link>
        <Link to="/contact">Contact</Link>
      </div>
    </nav>
  );
}

export default Navbar;